import { render, staticRenderFns } from "./whatsapps.vue?vue&type=template&id=a5d10770&scoped=true&"
import script from "./whatsapps.vue?vue&type=script&lang=js&"
export * from "./whatsapps.vue?vue&type=script&lang=js&"
import style0 from "./whatsapps.vue?vue&type=style&index=0&id=a5d10770&lang=scss&scoped=true&"
import style1 from "./whatsapps.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d10770",
  null
  
)

export default component.exports